import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{attrs:{"color":"grey lighten-3","light":""}},[_c(VCardText,[_c(VTimeline,{attrs:{"align-top":"","dense":""}},[_c(VTimelineItem,{attrs:{"color":"blue-grey"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c(VIcon,{attrs:{"small":"","dark":""}},[_vm._v("mdi-file-document-outline")])]},proxy:true}])},[_c('oficioDeparaTimelineComponent')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }